import React from 'react';
import Select from 'react-select';
import { reactSelectStyles } from './styles';
import { mergeSelectedOptions } from './storedValue';

const MultiValueSelect = ({ value, options, onChange, isLoading = false, placeholder, noOptionsMessage }) => (
  <Select
    isMulti
    classNamePrefix="audit-form-select"
    styles={reactSelectStyles}
    value={mergeSelectedOptions(value, options)}
    options={options}
    onChange={(selected) => onChange((selected || []).map((item) => item.value), selected || [])}
    isLoading={isLoading}
    placeholder={placeholder}
    noOptionsMessage={noOptionsMessage}
    closeMenuOnSelect={false}
    hideSelectedOptions={false}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
  />
);

export default MultiValueSelect;
